import Layout from '@/container/Full'

const BillingInvoiceList = () => import(/* webpackChunkName: "billing" */ './../views/billing/BillingListView')
const BillingInvoice = () => import(/* webpackChunkName: "billing" */ '../views/billing/BillingInvoiceView')
const PrintInvoice = () => import(/* webpackChunkName: "billing" */ '../views/billing/PrintInvoice')

const routes = [
  {
    path: '/billing',
    component: Layout,
    meta: {
      breadcrumb: 'Billing',
      pageTitle: 'Billing',
      access_type: 'authorized'
    },
    children: [
      {
        path: '',
        name: 'billing',
        component: BillingInvoiceList,
        meta: {
          access_type: 'authorized',
          pageTitle: 'Billing',
        }
      },
      {
        path: '/billing/:invoiceid',
        name: 'single_invoice',
        component: BillingInvoice,
        props: true,
        meta: {
          breadcrumb: routeParams => `Invoice #${routeParams.invoiceid}`,
          pageTitle: 'Billing',
          access_type: 'authorized'
        },
      }
    ]
  },
  {
    path: '/billing/print/:invoiceid',
    name: 'print_invoice',
    component: PrintInvoice,
    props: true,
    meta: {
      pageTitle: 'Billing',
      access_type: 'authorized'
    }
  }
]

export default routes
